
import React from "react";
import { TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { ChevronDown, ChevronUp } from "lucide-react";

export type SortField = 'email' | 'display_name' | 'role' | 'is_verified' | 'tos_accepted';
export type SortDirection = 'asc' | 'desc';

interface UserTableHeaderProps {
  sortField: SortField;
  sortDirection: SortDirection;
  handleSort: (field: SortField) => void;
}

export const UserTableHeader: React.FC<UserTableHeaderProps> = ({
  sortField,
  sortDirection,
  handleSort,
}) => {
  const renderSortIndicator = (field: SortField) => {
    if (sortField !== field) {
      return <ChevronDown className="h-4 w-4 opacity-30" />;
    }
    return sortDirection === 'asc' ? (
      <ChevronUp className="h-4 w-4" />
    ) : (
      <ChevronDown className="h-4 w-4" />
    );
  };

  return (
    <TableHeader>
      <TableRow>
        <TableHead 
          className="cursor-pointer hover:bg-gray-50" 
          onClick={() => handleSort('email')}
        >
          <div className="flex items-center">
            Email
            {renderSortIndicator('email')}
          </div>
        </TableHead>
        <TableHead 
          className="cursor-pointer hover:bg-gray-50"
          onClick={() => handleSort('display_name')}
        >
          <div className="flex items-center">
            Display Name
            {renderSortIndicator('display_name')}
          </div>
        </TableHead>
        <TableHead 
          className="cursor-pointer hover:bg-gray-50"
          onClick={() => handleSort('role')}
        >
          <div className="flex items-center">
            Role
            {renderSortIndicator('role')}
          </div>
        </TableHead>
        <TableHead 
          className="cursor-pointer hover:bg-gray-50"
          onClick={() => handleSort('is_verified')}
        >
          <div className="flex items-center">
            Status
            {renderSortIndicator('is_verified')}
          </div>
        </TableHead>
        <TableHead className="w-[150px]">Actions</TableHead>
      </TableRow>
    </TableHeader>
  );
};
